// 公共方法规则：首字母大写

/**
 * @desc 日期时间格式化
 * @param {string} [type='']
 * @returns
 */
function FormatDateTime(dateTime = new Date(), type = "") {
  let oldDateTime = dateTime;
  let newDateTime = "";

  let dividerDate = "-";
  let dividerTime = ":";

  let year = oldDateTime.getFullYear();
  let month = oldDateTime.getMonth() + 1;
  let date = oldDateTime.getDate();
  let hours = oldDateTime.getHours();
  let minutes = oldDateTime.getMinutes();
  let seconds = oldDateTime.getSeconds();

  if (month >= 1 && month <= 9) month = "0" + month;
  if (date >= 0 && date <= 9) date = "0" + date;
  if (hours >= 0 && hours <= 9) hours = "0" + hours;
  if (minutes >= 0 && minutes <= 9) minutes = "0" + minutes;
  if (seconds >= 0 && seconds <= 9) seconds = "0" + seconds;

  switch (type) {
    case "date":
      newDateTime = `${year}${dividerDate}${month}${dividerDate}${date}`;
      break;

    case "fullTime":
      newDateTime = `${hours}${dividerTime}${minutes}${dividerTime}${seconds}`;
      break;

    case "time":
      newDateTime = `${hours}${dividerTime}${minutes}`;
      break;

    case "dateTime":
      newDateTime = `${year}${dividerDate}${month}${dividerDate}${date} ${hours}${dividerTime}${minutes}`;
      break;

    default:
      newDateTime = `${year}${dividerDate}${month}${dividerDate}${date} ${hours}${dividerTime}${minutes}${dividerTime}${seconds}`;
  }
  return newDateTime;
}

/**
 * @desc 转换省市区数据格式
 * 将标准的省市区格式：{"110000":"北京市","120000":"天津市","130000":"河北省"……}，转换为 element-ui select 组件支持的数组形式：[{'110000':'北京市'},{'120000':'天津市'}，{'130000':'河北省'}……]
 */
function ObjectToArray(object) {
  return new Promise(resolve => {
    let arr = [];
    for (let key in object) {
      arr.push({
        label: object[key],
        value: key
      });
    }
    resolve(arr);
  });
}
/**
 * @desc 延迟执行，这个方式可以减少嵌套和代码量
 * @param timer 延迟时长（毫秒单位）
 */
function Wait(timer = 1000) {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve();
    }, timer);
  });
}

/**
 * @desc 对象序列化反序列化法
 */
function ObjectDeepClone(obj) {
  return JSON.parse(JSON.stringify(obj));
}


/**
 * @desc 两个时间差额
 */
function DiffTimestamp(timeBegin, timeEnd) {
  let beginTime = new Date(timeBegin).getTime();
  let endTime = new Date(timeEnd).getTime();

  let diff = endTime - beginTime;
  if (diff >= 0) {
    // 返回相差秒数
    return diff / 1000;
  }

  return false;
}

/**
 * @desc 删除左右两端的空格
 * @param str 要处理的字符串
 * @param type 删除类型：默认全部、lr：左右、l：左边、r：右边
 */
function Trim(str, type = "") {
  let strTrim = "";
  switch (type) {
    case "lr":
      strTrim = str.replace(/(^\s*)|(\s*$)/g, "");
      break;

    case "l":
      strTrim = str.replace(/(^\s*)/g, "");
      break;

    case "r":
      strTrim = str.replace(/(\s*$)/g, "");
      break;

    default:
      strTrim = str.replace(/\s+/g, "");
  }

  return strTrim;
}


/**
 * @desc 根据rank类型完成快速排序
 * @param arr 待排序数组
 * @param type1 进行排序的数据
 * @param type2 进行排序的类型
 */
function QicukSort(arr, type1, type2) {
  if (arr.length <= 1) {
    return arr
  }
  let pivotIndex = Math.floor(arr.length / 2)
  let pivotElement = arr.splice(pivotIndex, 1)[0]
  let pivot = pivotElement.rank[type1][type2].rank
  let left = []
  let right = []
  for (let i = 0; i < arr.length; i++) {
    if (arr[i].rank[type1][type2].rank < pivot) {
      left.push(arr[i])
    } else {
      right.push(arr[i])
    }
  }
  return QicukSort(left, type1, type2).concat(
    [pivotElement],
    QicukSort(right, type1, type2)
  )
}


// 公共方法，首字母大写
export {
  FormatDateTime,
  ObjectToArray,
  Wait,
  ObjectDeepClone,
  DiffTimestamp,
  Trim,
  QicukSort
};
